import { v4 as uuidv4 } from 'uuid';
export default class FnEditorId {
    createId() {
        return uuidv4();
    }
}
